module.exports = __webpack_public_path__ + "img/edit.2b43f03b.svg";